import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/src/constants';
import requestStatus from 'common/constants/status';

const initialState = {
  data: {
    list: [],
    myGroupSessions: []
  },
  filters: {
    trainer_id: [],
    session_type_id: [],
    status: ''
  },
  pagination: {
    first: 20,
    page: 1
  },
  paginatorInfo: {
    hasMorePages: false,
    total: 0
  },
  refresh: false,
  // Selección del panel two-pane (F3): qué sesión está abierta a la derecha y en qué modo.
  // detailMode: null | 'detail' (una sesión) | 'list' (lista filtrada por una card-counter).
  selectedSessionId: null,
  detailMode: null,
  listFilter: null,
  // true si el detalle se abrió DESDE una lista de card-counter (para mostrar botón "atrás").
  cameFromList: false,
  status: {
    general: requestStatus.idle,
    attendance: requestStatus.idle
  }
};

const groupSessionSlice = createSlice({
  name: 'groupSession',
  initialState,
  reducers: {
    create(state) {
      state.status.general = requestStatus.loading;
    },
    createSuccess(state) {
      state.status.general = requestStatus.success;
      state.refresh = true;
    },
    createError(state) {
      state.status.general = requestStatus.error;
    },

    list(state) {
      state.status.general = requestStatus.loading;
    },
    listSuccess(state, action) {
      state.status.general = requestStatus.success;
      state.data.list = action.payload.data;
      state.paginatorInfo = action.payload.paginatorInfo;
      state.refresh = false;
    },
    listError(state) {
      state.status.general = requestStatus.error;
    },

    fetchMyGroupSessions(state) {
      state.status.general = requestStatus.loading;
    },
    fetchMyGroupSessionsSuccess(state, action) {
      state.status.general = requestStatus.success;
      state.data.myGroupSessions = action.payload;
    },
    fetchMyGroupSessionsError(state) {
      state.status.general = requestStatus.error;
    },

    update(state) {
      state.status.general = requestStatus.loading;
    },
    updateSuccess(state) {
      state.status.general = requestStatus.success;
      state.refresh = true;
    },
    updateError(state) {
      state.status.general = requestStatus.error;
    },

    markAttendance(state) {
      state.status.attendance = requestStatus.loading;
    },
    markAttendanceSuccess(state) {
      state.status.attendance = requestStatus.success;
      state.refresh = true;
    },
    markAttendanceError(state) {
      state.status.attendance = requestStatus.error;
    },

    deleteSession(state) {
      state.status.general = requestStatus.loading;
    },
    deleteSessionSuccess(state) {
      state.status.general = requestStatus.success;
      state.refresh = true;
    },
    deleteSessionError(state) {
      state.status.general = requestStatus.error;
    },

    // ── Panel two-pane (F3) ──
    selectSession(state, action) {
      // Si veníamos de una lista de counter, conservamos listFilter para poder volver.
      state.cameFromList = state.detailMode === 'list';
      if (!state.cameFromList) state.listFilter = null;
      state.selectedSessionId = action.payload;
      state.detailMode = 'detail';
    },
    showCounterList(state, action) {
      state.listFilter = action.payload; // 'scheduled' | 'pending' | 'completed' | 'absent'
      state.detailMode = 'list';
      state.selectedSessionId = null;
      state.cameFromList = false;
    },
    backToList(state) {
      state.detailMode = 'list';
      state.selectedSessionId = null;
      state.cameFromList = false;
    },
    clearSelection(state) {
      state.selectedSessionId = null;
      state.detailMode = null;
      state.listFilter = null;
      state.cameFromList = false;
    },

    updateFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
    setPage(state, action) {
      state.pagination.page = action.payload;
    },
    resetRefresh(state) {
      state.refresh = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default groupSessionSlice;
